export default "__VITE_ASSET__VSE3_W2x__"